import Default from './default';
import Primary from './primary';
import Secondary from './secondary';

const Image = {
  Default,
  Primary,
  Secondary,
};

export default Image;
